// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var BrowserComponents_Image = require("../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");

var logo = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(1.7)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(4.5)),
        tl: /* [] */0
      }
    });

var Styles = {
  logo: logo
};

function WebComponents_Header$Logo(Props) {
  var onClick = Props.onClick;
  return React.createElement(BrowserComponents_Button.Base.make, {
              children: React.createElement(BrowserComponents_Image.make, {
                    className: logo,
                    image: {
                      TAG: /* Logo */2,
                      _0: /* Light */6
                    }
                  }),
              onClick: (function (param) {
                  return onClick;
                })
            });
}

var Logo = {
  Styles: Styles,
  make: WebComponents_Header$Logo
};

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.backgroundColor({
              TAG: /* Blue */0,
              _0: /* Darkest */0
            }),
        tl: {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 0.0
              }),
          tl: {
            hd: BrowserStyle.height(BrowserStyle.rem(3.75)),
            tl: {
              hd: BrowserStyle.minHeight(BrowserStyle.rem(3.75)),
              tl: {
                hd: BrowserStyle.maxHeight(BrowserStyle.rem(3.75)),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
                  tl: {
                    hd: BrowserStyle.padding2(BrowserStyle.zero, BrowserStyle.Spacing.large),
                    tl: {
                      hd: BrowserStyle.position(BrowserStyle.sticky),
                      tl: {
                        hd: BrowserStyle.top(BrowserStyle.zero),
                        tl: {
                          hd: BrowserStyle.zIndex(50),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles$1 = {
  container: container
};

function WebComponents_Header$Desktop(Props) {
  var children = Props.children;
  var className = Props.className;
  var logoContainerClassName = Props.logoContainerClassName;
  var onLogoClick = Props.onLogoClick;
  var tmp = {
    children: null
  };
  if (logoContainerClassName !== undefined) {
    tmp.className = Caml_option.valFromOption(logoContainerClassName);
  }
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: BrowserStyle.Utils.extendBaseStyle(container, className),
              children: null
            }, React.createElement(BrowserComponents_FlexRow.make, tmp, React.createElement(WebComponents_Header$Logo, {
                      onClick: onLogoClick
                    }), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    })), children);
}

var Desktop = {
  Styles: Styles$1,
  make: WebComponents_Header$Desktop
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* Blue */0,
            _0: /* Darkest */0
          }),
      tl: {
        hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
        tl: {
          hd: BrowserStyle.flexShrink(0.0),
          tl: {
            hd: BrowserStyle.height(BrowserStyle.rem(2.5)),
            tl: {
              hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
              tl: {
                hd: BrowserStyle.overflowY("hidden"),
                tl: {
                  hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.small),
                  tl: {
                    hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.small),
                    tl: {
                      hd: BrowserStyle.width(BrowserStyle.vw(100.0)),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var rightSideEmptySpace = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.rem(1.5)),
      tl: /* [] */0
    });

var Styles$2 = {
  container: container$1,
  rightSideEmptySpace: rightSideEmptySpace
};

function WebComponents_Header$Mobile(Props) {
  var onLogoClick = Props.onLogoClick;
  var onMenuClick = Props.onMenuClick;
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: container$1,
              children: null
            }, React.createElement(BrowserComponents_Button.Icon.make, {
                  icon: {
                    TAG: /* Small */1,
                    _0: {
                      TAG: /* Navigation */5,
                      _0: /* Menu */3
                    }
                  },
                  iconColor: {
                    TAG: /* White */7,
                    _0: /* Light */2
                  },
                  onClick: (function (param) {
                      return onMenuClick;
                    }),
                  size: /* Large */3
                }), React.createElement(WebComponents_Header$Logo, {
                  onClick: onLogoClick
                }), React.createElement("div", {
                  className: rightSideEmptySpace
                }));
}

var Mobile = {
  Styles: Styles$2,
  make: WebComponents_Header$Mobile
};

exports.Logo = Logo;
exports.Desktop = Desktop;
exports.Mobile = Mobile;
/* logo Not a pure module */
